export default {
  h1: {
    fontWeight: 500,
    fontSize: 35,
    letterSpacing: '-0.24px',
    fontFamily: '"Poppins", sans-serif',
  },
  h2: {
    fontWeight: 500,
    fontSize: 29,
    letterSpacing: '-0.24px',
    fontFamily: '"Poppins", sans-serif',
  },
  h3: {
    fontWeight: 500,
    fontSize: 24,
    letterSpacing: '-0.06px',
    fontFamily: '"Poppins", sans-serif',
  },
  h4: {
    fontWeight: 500,
    fontSize: 20,
    letterSpacing: '-0.06px',
    fontFamily: '"Poppins", sans-serif',
  },
  h5: {
    fontWeight: 500,
    fontSize: 16,
    letterSpacing: '-0.05px',
    fontFamily: '"Poppins", sans-serif',
  },
  h6: {
    fontWeight: 500,
    fontSize: 14,
    letterSpacing: '-0.05px',
    fontFamily: '"Poppins", sans-serif',
  },
  body: {
    fontFamily: '"Poppins", sans-serif',
  },
  body2: {
    fontFamily: '"Poppins", sans-serif',
  },
  overline: {
    fontWeight: 500,
    fontFamily: '"Poppins", sans-serif',
  }
};
